import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const CloseIcon = styled.div`
  cursor: pointer;
  color: ${colors.strongGray};
  position: absolute;
  top: -25px;
  right: 1px;
`
export const Title = styled.div`
    font-size: 32px;
    font-weight: bold;
    color: ${colors.titleStrongBlack};
`
export const Subtitle = styled.div`
    font-size: 16px;
    color: ${colors.strongGray};
`
export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
    `
export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    `
